import { MESSENGER_APPID } from "@/constants/environment";
import { DeviceContext } from "@/context/device.context";
import CopyLink from "@components/Share/CopyLink";
import ShareFacebook from "@components/Share/ShareFacebook";
import ShareMessenger from "@components/Share/ShareMessenger";
import ShareTeleGram from "@components/Share/ShareTeleGram";
import ShareWhatApp from "@components/Share/ShareWhatApp";
import ShareZalo from "@components/Share/ShareZalo";
import { Button, Drawer, Popover } from "antd";
import { ReactNode, useContext, useState } from "react";

export interface IShareProps {
  url: string;
  appId?: string;
}

type IShareButtonProps = {
  children: ReactNode;
  shareUrl: string;
};

const ShareButton = ({ children, shareUrl }: IShareButtonProps) => {
  const { isMobile } = useContext(DeviceContext);
  const [isShowOther, setShowOther] = useState(false);
  const [isOpenDrawer, setOpenDrawer] = useState(false);
  // useEffect(() => {
  //   if (isOpenDrawer) document.body.style.overflow = "hidden";
  //   else document.body.style.overflow = "auto";
  // }, [isOpenDrawer]);
  return (
    <>
      {!isMobile ? (
        <Popover
          destroyTooltipOnHide
          onOpenChange={() => setShowOther(false)}
          showArrow={true}
          content={
            <div className="flex flex-col">
              <ShareFacebook url={shareUrl} />
              <ShareZalo url={shareUrl} />
              <CopyLink url={shareUrl} />
              {isShowOther ? (
                <>
                  <ShareMessenger url={shareUrl} appId={MESSENGER_APPID} />
                  <ShareWhatApp url={shareUrl} />
                  <ShareTeleGram url={shareUrl} />
                  {/* <ShareViber url={shareUrl} /> */}
                </>
              ) : (
                <div
                  className="w-full flex md:justify-center items-center cursor-pointer p-3 md:p-0 hover:bg-grey-50"
                  onClick={() => {
                    setShowOther(true);
                  }}>
                  <i className="mrv mrv-keyboard_arrow_down md:text-fs-20 text-fs-24 text-grey-800 rounded-[24px] bg-grey-50 md:bg-transparent" />
                </div>
              )}
            </div>
          }
          trigger={["click"]}
          placement="bottomLeft"
          overlayClassName="z-[10]">
          {children}
        </Popover>
      ) : (
        <>
          <span
            onClick={() => {
              document.body.style.overflow = "hidden";
              setOpenDrawer(true);
            }}>
            {children}
          </span>
          <Drawer
            placement={"bottom"}
            open={isOpenDrawer}
            className={"rounded-t-3xl"}
            title={
              <div className="w-full flex flex-row justify-between items-center right-0">
                <Button className="bg-transparent shadow-none border-0"></Button>
                <div className="flex text-center">Chia sẻ</div>
                <Button
                  className="flex border-0 bg-transparent shadow-none items-center order-last"
                  onClick={() => {
                    setOpenDrawer(false);
                    document.body.style.overflow = "auto";
                  }}>
                  <i className="mrv mrv-close text-fs-24 flex justify-center text-center items-center" />
                </Button>
              </div>
            }
            headerStyle={{ background: "#EBF3FC", padding: "0.5rem" }}
            closeIcon={null}
            height={"auto"}
            maskClosable={true}
            onClose={() => {
              setOpenDrawer(false);
              setShowOther(false);
              document.body.style.overflow = "auto";
            }}
            destroyOnClose>
            <div className="flex flex-col">
              <ShareFacebook url={shareUrl} />
              <ShareZalo url={shareUrl} />
              <CopyLink url={shareUrl} />
              {isShowOther ? (
                <>
                  <ShareMessenger url={shareUrl} appId={MESSENGER_APPID} />
                  <ShareWhatApp url={shareUrl} />
                  <ShareTeleGram url={shareUrl} />
                  {/* <ShareViber url={shareUrl}/> */}
                </>
              ) : (
                <div
                  className="w-full flex md:justify-center items-center cursor-pointer p-3 md:p-0 hover:bg-grey-50"
                  onClick={() => {
                    setShowOther(true);
                  }}>
                  <i className="mrv mrv-keyboard_arrow_down md:text-fs-20 text-fs-24 text-grey-800 rounded-full bg-grey-50 md:bg-transparent" />
                  <div className="text-fs-14 text-grey-800 font-medium ml-3">
                    Xem thêm lựa chọn
                  </div>
                </div>
              )}
            </div>
          </Drawer>
        </>
      )}
    </>
  );
};

export default ShareButton;
